import { Component, Inject, OnInit } from '@angular/core';
import { LOCALE_ID } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginModel } from '../../models/login.model';
import { AuthenticationService } from '../../core/authentication/auth.service';
import { ClientService } from '../../services/client.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'nli-login',
  templateUrl: './nli-login.component.html',
  styleUrls: ['./nli-login.component.scss']
})
export class LoginComponent implements OnInit {
  public loginModel: LoginModel;
  loginForm: FormGroup;
  errorMessage: string;
  res: boolean;
  loading = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private clientService: ClientService,
    private translateService: TranslateService
  ) {

    if (this.authenticationService.isKeycloakEnabled()) {
      this.router.navigate(['/clients']);
    }

      this.authenticationService.isLoggedIn().subscribe((isLoggedIn: boolean) => {
        if (isLoggedIn) {
          if (clientService.getClientCount() === 1) {
            this.router.navigate(['/loggedIn']);
          } else {
            this.router.navigate(['/clients']);
          }
        }
      });



    this.loginForm = fb.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  ngOnInit() {}

  submitForm() {
    this.loading = true;
    this.errorMessage = '';
    this.authenticationService.login(this.loginForm.value.username, this.loginForm.value.password).subscribe(
      result => {
        if (result === true) {
          // login successful
          localStorage.setItem('username', this.loginForm.value.username);
          this.handleResponse(result);
        } else {
          // login failed
          this.translateService.get('Login.usernameOrPasswordIsWrong').subscribe(msg => {
            this.errorMessage = msg;
          });
        }
        this.loading = false;
      },
      err => {
        if (!err) {
          this.translateService.get('App.serverError').subscribe(msg => {
            this.errorMessage = msg;
          });
        } else {
          this.errorMessage = err;
        }
        this.loading = false;
      }
    );
  }

  handleResponse(clients: any): void {
    if (clients.length === 1) {
      this.clientService.resetClient(clients[0], 1);
      this.router.navigate(['/loggedIn']);
    } else {
      this.router.navigate(['/clients']);
    }
  }
}
